import { apm } from "@/shared/lib/apmClient";

apm.addLabels({
  instrumentation: "client",
});
